import { Component, inject } from '@angular/core';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { SortFilterComponent } from '../../../pages/search-result/components/filters/sort-filter/sort-filter.component';

@Component({
  selector: 'iho-sticky-searchbox',
  templateUrl: './sticky-searchbox.component.html',
  standalone: true,
  imports: [SharedModule, SortFilterComponent],
  styleUrls: ['./sticky-searchbox.component.scss'],
})
export class StickySearchboxComponent {

  /*
    - inject
  */
  router = inject(Router)
  searchSVC = inject(SearchBoxService)

  triggerSearch() {
    const startDate = this.searchSVC.getStartAndEndDate()[0]
    const endDate = this.searchSVC.getStartAndEndDate()[1]
    const residentTypeKey = this.getResidentTypeName()
    let queryParams = {
      minPrice: null,
      maxPrice: null,
      labels: null,
      types: null,
      grades: null,
      reviews: null,
      date: startDate,
      endDate: endDate,
      type: String(this.searchSVC.residentType)
    }
    if (residentTypeKey) (queryParams as any)[residentTypeKey] = String(this.searchSVC.residentId)
    this.router.navigate(
      [this.searchSVC.urlToRedirect], // could be ecolodge or hotel
      {
        queryParams: {
          search_box: this.searchSVC.residentName || null,
          ...queryParams
        }
      }
    )
  }

  getResidentTypeName() {
    let residentTypeKey = ''
    if (this.searchSVC.residentType === 1) residentTypeKey = 'city'
    else if (this.searchSVC.residentType === 2) residentTypeKey = 'region'
    else if (this.searchSVC.residentType === 3) residentTypeKey = 'hid'
    else if (this.searchSVC.residentType === 4) residentTypeKey = 'district'
    else if (this.searchSVC.residentType === 5) residentTypeKey = 'state'
    return residentTypeKey
  }

}
